/** Words are non-whitespace runs after HTML tags are removed. */
export function countWords(value: string | null | undefined): number {
  if (!value) return 0;
  const text = value
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&quot;/gi, '"')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\u00a0/g, ' ');
  const matches = text.match(/\S+/g);
  return matches ? matches.length : 0;
}
